import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=15684f0f&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=15684f0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15684f0f",
  null
  
)

export default component.exports